// extracted by mini-css-extract-plugin
module.exports = {"block":"CzLaY","title":"_4wjk3","link":"_1ZMET","tel":"vZaOV","contacts":"HDqeQ","partners":"L2eTu","partnerLink":"lScUG"};